import React from 'react';

const ServiceNotAvailable = () => {
  return (
    <div>
      <p>Vous n’avez pas accès à cette fonctionnalité.</p>
      <p>Pour la débloquer, merci de contacter nos équipes.</p>
    </div>
  );
};

export default ServiceNotAvailable;
